import { useSyncExternalStore } from "react";

const MOBILE_MAX_WIDTH = 1167;

const subscribe = (onChange: () => void) => {
  window.addEventListener("resize", onChange);
  return () => window.removeEventListener("resize", onChange);
};

const getSnapshot = () => window.innerWidth <= MOBILE_MAX_WIDTH;

// The server has no viewport: render the desktop variant there and while
// hydrating, then React switches to the real value. Layout chrome that must
// not flash uses CSS media queries instead (see Layout).
const getServerSnapshot = () => false;

export const useIsMobile = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
